var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '@shapeable/utils';
var cls = classNames('person-bio-grid');
import { breakpoints, theme } from '@shapeable/theme';
import { PersonBioCell } from './person-bio-cell';
export var PersonBioGridDefaultProps = {
  items: []
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    align-items: center;\n    justify-content: center;\n    display: flex;\n    flex-direction: column;\n    a {\n      text-decoration: none;\n    }\n  "], ["\n    align-items: center;\n    justify-content: center;\n    display: flex;\n    flex-direction: column;\n    a {\n      text-decoration: none;\n    }\n  "]))),
  landscape: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    align-items: flex-start;\n    flex-wrap: wrap;\n    flex-direction: row;\n  "], ["\n    align-items: flex-start;\n    flex-wrap: wrap;\n    flex-direction: row;\n  "])))
});
var PersonStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    margin-bottom: ", ";\n    margin-left: ", ";\n    margin-right: ", ";\n    flex-basis: calc(20% - ", ");\n  "], ["\n    margin-bottom: ", ";\n    margin-left: ", ";\n    margin-right: ", ";\n    flex-basis: calc(20% - ", ");\n  "])), theme.UNIT(10), theme.UNIT(5), theme.UNIT(5), theme.UNIT(10)),
  tablet: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    margin-bottom: ", ";\n\n    &:last-child {\n      margin-right: 0;\n    }\n  "], ["\n    margin-bottom: ", ";\n\n    &:last-child {\n      margin-right: 0;\n    }\n  "])), theme.UNIT(4))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Person: styled(PersonBioCell)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), PersonStyles)
};
export var PersonBioGrid = function (props) {
  var className = props.className,
    children = props.children,
    transform = props.transform,
    showEmailContact = props.showEmailContact,
    showOrganisation = props.showOrganisation,
    items = props.items;
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, items.map(function (person) {
    return React.createElement(My.Person, {
      showEmailContact: showEmailContact,
      showOrganisation: showOrganisation,
      transform: transform,
      key: person.id,
      entity: person
    });
  }), children);
};
PersonBioGrid.defaultProps = PersonBioGridDefaultProps;
PersonBioGrid.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;